import { render, staticRenderFns } from "./MergePatientDropdown.vue?vue&type=template&id=c4f8de0c&scoped=true&lang=pug&"
import script from "./MergePatientDropdown.vue?vue&type=script&lang=js&"
export * from "./MergePatientDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f8de0c",
  null
  
)

export default component.exports